<template>
   <BreadCrumb PageTitle="Modifier un support de cours" />
    <EditSupport />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditSupport from "@/components/SupportDeCours/EditSupport.vue";
  
    export default defineComponent({
      name: "EditSupportPage",
      components: {
        BreadCrumb,
        EditSupport,
      },
    });
  </script>